import { MutationTree } from 'vuex'

import { ItemGroup } from '@/models'

import { MenuState } from '../state'

export const ADD_ITEM_GROUP = 'ADD_ITEM_GROUP'
export const INCREMENT_ITEM_GROUPS_QUERY_INDEX = 'INCREMENT_ITEM_GROUPS_QUERY_INDEX'
export const LOADED_ALL_ITEM_GROUPS = 'LOADED_ALL_ITEM_GROUPS'
export const REMOVE_ITEM_GROUP = 'REMOVE_ITEM_GROUP'
export const RESET_ITEM_GROUPS_QUERY_INDEX = 'RESET_ITEM_GROUPS_QUERY_INDEX'
export const RESET_LOADED_ALL_ITEM_GROUPS = 'RESET_LOADED_ALL_ITEM_GROUPS'
export const UPDATE_ITEM_GROUPS = 'UPDATE_ITEM_GROUPS'
export const UPDATE_ITEM_GROUPS_TOTAL = 'UPDATE_ITEM_GROUPS_TOTAL'

const mutations: MutationTree<MenuState> = {
  [ADD_ITEM_GROUP] (state, itemGroup: ItemGroup) {
    state.itemGroups.elements.push(itemGroup)
  },

  [INCREMENT_ITEM_GROUPS_QUERY_INDEX] (state, offset: number) {
    state.itemGroups.query.index = (state.itemGroups.query.index ?? 0) + offset
  },

  [LOADED_ALL_ITEM_GROUPS] (state) {
    state.itemGroups.didLoadAll = true
  },

  [REMOVE_ITEM_GROUP] (state, id: number) {
    const index = state.itemGroups.elements.findIndex((i) => i.id === id)

    if (index >= 0) {
      state.itemGroups.elements.splice(index, 1)
    }
  },

  [RESET_ITEM_GROUPS_QUERY_INDEX] (state) {
    state.itemGroups.query.index = 0
  },

  [RESET_LOADED_ALL_ITEM_GROUPS] (state) {
    state.itemGroups.didLoadAll = false
  },

  [UPDATE_ITEM_GROUPS] (state, itemGroups: ItemGroup[]) {
    state.itemGroups.elements = itemGroups
  },

  [UPDATE_ITEM_GROUPS_TOTAL] (state, total: number) {
    state.itemGroups.total = total
  }
}

export default mutations
